import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CampaignWizard from '../../campaign-wizard/CampaignWizard';
import campaignService from '../../../services/campaign.service';
import { useEyeconxStore } from '../../../store/eyeconxStore';

function CreateSms() {
    const navigate = useNavigate();
    const clinicId = useEyeconxStore((state) => state.user?.clinicId);

    const steps = [
        { id: 1, title: 'Message Content', subtitle: 'Write SMS with keywords', component: 'MessageContent' },
        { id: 2, title: 'Blast Information', subtitle: 'Basic information', component: 'CampaignInformation' },
        { id: 3, title: 'Patient List', subtitle: 'Select patients that will receive SMS', component: 'PatientList' },
        { id: 4, title: 'Complete', subtitle: 'Process the Blast', component: 'Complete' },
    ];

    const handleSubmit = async (formData) => {
        const name = formData.campaignName?.trim();
        const message = formData.messageContent?.trim();
        const patientIds = (formData.selectedPatients || [])
            .map((patient) => patient.id)
            .filter(Boolean);

        if (!clinicId) {
            toast.error('Clinic is not available. Please sign in again.');
            return;
        }
        if (!name) {
            toast.error('Blast name is required.');
            return;
        }
        if (!message) {
            toast.error('SMS message is required.');
            return;
        }
        if (patientIds.length === 0) {
            toast.error('Select at least one patient before launching.');
            return;
        }

        try {
            const response = await campaignService.launchSmsBlast(clinicId, {
                name,
                description: formData.description?.trim() || undefined,
                message,
                patientIds,
            });
            const recipientCount = response.data?.recipientCount ?? patientIds.length;
            toast.success(
                `SMS blast submitted for ${recipientCount} recipient${recipientCount === 1 ? '' : 's'}. Queueing runs in the background.`
            );
            navigate('/blast/sms');
        } catch (error) {
            console.error('Failed to launch SMS blast', error);
            toast.error(error?.response?.data?.errorMessage || 'Could not launch SMS blast.');
            throw error;
        }
    };

    return (
        <CampaignWizard
            title="Create SMS Blast"
            description="Communicate with patients using SMS."
            icon="bi-chat-dots"
            navigatePath="/blast/sms"
            campaignType="sms"
            entityLabel="Blast"
            steps={steps}
            onSubmit={handleSubmit}
        />
    );
}

export default CreateSms;
